const contactFields = [
  {
    label: "Address",
    value: "Antuna Aksamovica 44",
    icon: "ri-map-pin-2-line",
  },
  {
    label: "City",
    value: "Vinkovci",
    icon: "ri-building-2-line",
  },
  {
    label: "Zip",
    value: "32100",
    icon: "ri-mail-send-line",
  },
  {
    label: "Country",
    value: "Croatia",
    icon: "ri-flag-2-line",
  },
  {
    label: "Email",
    value: "info@xedradoo.com",
    icon: "ri-mail-line",
    isEmail: true,
  },
  {
    label: "Number",
    value: "+1 5186327503",
    icon: "ri-phone-line",
    isPhone: true,
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Heading */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-widest text-gray-400 mb-3 font-medium">Reach Out</p>
          <h2 className="text-4xl md:text-5xl font-extralight text-gray-900">
            Get in <span className="font-semibold">Touch</span>
          </h2>
          <p className="mt-4 text-base text-gray-500 max-w-lg mx-auto leading-relaxed">
            Have a question about our products or want to get in touch with our team? Here&apos;s how to find us.
          </p>
        </div>

        {/* Two-column layout */}
        <div className="flex flex-col lg:flex-row gap-12 items-start justify-center">
          {/* Left: contact info card */}
          <div className="w-full lg:max-w-xl bg-gray-50 rounded-2xl border border-gray-100 p-8 md:p-10">
            <h3 className="text-lg font-semibold text-gray-900 mb-8">Contact Information</h3>

            {/* Address group */}
            <div className="mb-8">
              <p className="text-xs uppercase tracking-widest text-gray-400 mb-4 font-medium">Location</p>
              <div className="flex flex-col gap-4">
                {contactFields.slice(0, 4).map((field) => (
                  <div key={field.label} className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 flex-shrink-0">
                      <i className={`${field.icon} text-base text-gray-600`} />
                    </div>
                    <div>
                      <span className="block text-xs text-gray-400 uppercase tracking-wider mb-0.5 font-medium">
                        {field.label}
                      </span>
                      <span className="block text-sm font-medium text-gray-800">{field.value}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="h-px bg-gray-200 mb-8" />

            {/* Communication group */}
            <div>
              <p className="text-xs uppercase tracking-widest text-gray-400 mb-4 font-medium">Communication</p>
              <div className="flex flex-col gap-4">
                {contactFields.slice(4).map((field) => (
                  <div key={field.label} className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 flex-shrink-0">
                      <i className={`${field.icon} text-base text-gray-600`} />
                    </div>
                    <div>
                      <span className="block text-xs text-gray-400 uppercase tracking-wider mb-0.5 font-medium">
                        {field.label}
                      </span>
                      <span className="block text-sm font-medium text-gray-800">{field.value}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: company blurb + map placeholder */}
          <div className="w-full lg:max-w-lg flex flex-col gap-6">
            <div className="bg-gray-950 rounded-2xl overflow-hidden w-full h-56 md:h-72">
              <img
                src="https://public.readdy.ai/ai/img_res/549209f8d59d79e6ebcc28a9ee895555.jpg"
                alt="Vinkovci, Croatia — XEDRA d.o.o. headquarters"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="bg-gray-50 rounded-2xl border border-gray-100 p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src="https://public.readdy.ai/ai/img_res/02174966-2660-4708-9146-ceac0d641290.png"
                  alt="XEDRA logo"
                  className="h-7 w-auto object-contain"
                />
                <span className="text-sm font-semibold text-gray-900">XEDRA d.o.o.</span>
              </div>
              <p className="text-sm text-gray-500 leading-relaxed">
                We&apos;re based in Vinkovci, Croatia, but our products reach users worldwide. Whether you&apos;re a user with a question, a partner, or a journalist — we&apos;re happy to hear from you.
              </p>

              <div className="mt-5 flex flex-col gap-2">
                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-mail-line text-gray-400" />
                  <span className="font-medium">Email:</span>
                  <span className="text-gray-600">info@xedradoo.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-phone-line text-gray-400" />
                  <span className="font-medium">Number:</span>
                  <span className="text-gray-600">+1 5186327503</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
